import { IAdminItemData } from '@features/admin/interfaces/admin-item-data.interface';

export enum AdminItem {
  USER = 'user',
  // directory
  ROLES = 'roles',
  REGIONS = 'regions',
  DISTRICTS = 'districts',
  ORGANIZATIONS = 'organizations',
  BRANCHES = 'branches',
  FUEL_TYPE = 'fuel-types',
  TECHNIQUE_TYPE = 'technique-types',
  TECHNIQUES = 'TECHNIQUES',
  WAREHOUSE = 'warehouse',
  COMPLEXES = 'complexes',
  BRIGADE = 'brigade',
  PRODUCT_TYPES = 'product-types',
  PRODUCTS = 'products',
  PRODUCT_TYPE_PARAMS = 'product-type-params',
  DRONES = 'drones',
  CARS = 'cars',
  BRIGADE_REQUESTS = 'brigade-requests',
  WAREHOUSE_REQUESTS = 'warehouse-requests',
}

export enum AdminEntities {
  ROLES_PERMISSIONS = 'role-permissions',
  ROLE_WITH_PERMISSIONS = 'role-with-permissions',
  ORGANIZATIONS_USERS = 'organizations-users',
  ORGANIZATIONS_USERS_BY_USER = 'organizations-users-by-user',
}

export const NAME_COLUMNS = [
  { title: 'in.latin', dataKey: 'names.uz' },
  { title: 'in.cyrillic', dataKey: 'names.uz_cyr' },
  { title: 'in.russian', dataKey: 'names.ru' },
];

export const LOCATION_COLUMNS = [
  { title: 'in.latin', dataKey: 'names.uz' },
  { title: 'in.russian', dataKey: 'names.ru' },
  { title: 'region', dataKey: 'region_id' },
  { title: 'district', dataKey: 'district_id' },
];

export const ADMIN_ITEMS_DATA: { [key in AdminItem]: IAdminItemData } = {
  [AdminItem.USER]: {
    id: AdminItem.USER,
    title: 'users',
    navigation: {
      id: 'admin',
      title: 'user',
      type: 'basic',
      icon: 'mat_outline:people',
      link: `/admin/dashboard/${AdminItem.USER}`,
    },
    hasActions: true,
    columns: [
      { title: 'last.name', dataKey: 'last_name' },
      { title: 'first.name', dataKey: 'first_name' },
      { title: 'username', dataKey: 'username' },
      { title: 'phone', dataKey: 'phone_number' },
      { title: 'roles', dataKey: 'roles' },
    ],
  },
  [AdminItem.BRANCHES]: {
    id: AdminItem.BRANCHES,
    title: 'branches',
    navigation: {
      id: 'admin',
      title: 'branches',
      type: 'basic',
      icon: 'mat_outline:call_split',
      link: `/admin/dashboard/${AdminItem.BRANCHES}`,
    },
    hasActions: true,
    columns: NAME_COLUMNS,
  },
  [AdminItem.TECHNIQUES]: {
    id: AdminItem.TECHNIQUES,
    title: 'techniques',
    navigation: {
      id: 'admin',
      title: 'techniques',
      type: 'basic',
      icon: 'mat_outline:precision_manufacturing',
      link: `/admin/dashboard/${AdminItem.TECHNIQUES}`,
    },
    hasActions: true,
    columns: [
      { title: 'name', dataKey: 'name' },
      { title: 'model', dataKey: 'model' },
      { title: 'state_number', dataKey: 'state_number' },
      { title: 'branch', dataKey: 'branch_id' },
      { title: 'status', dataKey: 'status' },
    ],
  },
  [AdminItem.ROLES]: {
    id: AdminItem.ROLES,
    title: 'roles',
    navigation: {
      id: 'admin',
      title: 'roles',
      type: 'basic',
      icon: 'mat_outline:vpn_key',
      link: `/admin/dashboard/${AdminItem.ROLES}`,
    },
    hasActions: true,
    columns: NAME_COLUMNS,
  },
  [AdminItem.REGIONS]: {
    id: AdminItem.REGIONS,
    title: 'regions',
    navigation: {
      id: 'admin',
      title: 'regions',
      type: 'basic',
      icon: 'mat_outline:map',
      link: `/admin/dashboard/${AdminItem.REGIONS}`,
    },
    hasActions: true,
    columns: NAME_COLUMNS,
  },
  [AdminItem.DISTRICTS]: {
    id: AdminItem.DISTRICTS,
    title: 'districts',
    navigation: {
      id: 'admin',
      title: 'districts',
      type: 'basic',
      icon: 'mat_outline:location_on',
      link: `/admin/dashboard/${AdminItem.DISTRICTS}`,
    },
    hasActions: true,
    columns: NAME_COLUMNS,
  },
  [AdminItem.ORGANIZATIONS]: {
    id: AdminItem.ORGANIZATIONS,
    title: 'organizations',
    navigation: {
      id: 'admin',
      title: 'organizations',
      type: 'basic',
      icon: 'mat_outline:home_work',
      link: `/admin/dashboard/${AdminItem.ORGANIZATIONS}`,
    },
    hasActions: true,
    columns: [
      ...NAME_COLUMNS,
      { title: 'tin', dataKey: 'tin' },
      { title: 'phone', dataKey: 'phone_number' },
      { title: 'address', dataKey: 'address' },
    ],
  },
  [AdminItem.WAREHOUSE]: {
    id: AdminItem.WAREHOUSE,
    title: 'warehouse',
    navigation: {
      id: 'admin',
      title: 'warehouse',
      type: 'basic',
      icon: 'mat_outline:home',
      link: `/admin/dashboard/${AdminItem.WAREHOUSE}`,
    },
    hasActions: true,
    columns: [
      { title: 'in.latin', dataKey: 'names.uz' },
      { title: 'category', dataKey: 'category' },
      { title: 'phone', dataKey: 'phone_number' },
    ],
  },
  [AdminItem.COMPLEXES]: {
    id: AdminItem.COMPLEXES,
    title: 'complexes',
    navigation: {
      id: 'admin',
      title: 'complexes',
      type: 'basic',
      icon: 'mat_outline:domain',
      link: `/admin/dashboard/${AdminItem.COMPLEXES}`,
    },
    hasActions: true,
    // columns: [...NAME_COLUMNS, { title: 'warehouse', dataKey: 'warehouse_id' }],
    columns: [...NAME_COLUMNS],
  },
  [AdminItem.BRIGADE]: {
    id: AdminItem.BRIGADE,
    title: 'brigades',
    navigation: {
      id: 'admin',
      title: 'brigades',
      type: 'basic',
      icon: 'mat_outline:groups',
      link: `/admin/dashboard/${AdminItem.BRIGADE}`,
    },
    hasActions: true,
    columns: [
      ...NAME_COLUMNS,
      { title: 'warehouse', dataKey: 'warehouse' },
      { title: 'complex', dataKey: 'complex' },
      { title: 'operators', dataKey: 'operators' },
    ],
  },
  [AdminItem.FUEL_TYPE]: {
    id: AdminItem.FUEL_TYPE,
    title: 'fuel.types',
    navigation: {
      id: 'admin',
      title: 'fuel.types',
      type: 'basic',
      icon: 'mat_outline:local_gas_station',
      link: `/admin/dashboard/${AdminItem.FUEL_TYPE}`,
    },
    hasActions: true,
    columns: NAME_COLUMNS,
  },
  [AdminItem.TECHNIQUE_TYPE]: {
    id: AdminItem.TECHNIQUE_TYPE,
    title: 'technique.types',
    navigation: {
      id: 'admin',
      title: 'technique.types',
      type: 'basic',
      icon: 'mat_outline:commute',
      link: `/admin/dashboard/${AdminItem.TECHNIQUE_TYPE}`,
    },
    hasActions: true,
    columns: [{ title: 'external', dataKey: 'external_id' }, ...NAME_COLUMNS],
  },
  [AdminItem.PRODUCT_TYPES]: {
    id: AdminItem.PRODUCT_TYPES,
    title: 'product_types',
    navigation: {
      id: 'admin',
      title: 'product_types',
      type: 'basic',
      icon: 'mat_outline:inventory_2',
      link: `/admin/dashboard/${AdminItem.PRODUCT_TYPES}`,
    },
    hasActions: true,
    columns: [...NAME_COLUMNS, { title: 'code', dataKey: 'code' }, { title: 'category', dataKey: 'category' }],
  },
  [AdminItem.PRODUCTS]: {
    id: AdminItem.PRODUCTS,
    title: 'products',
    navigation: {
      id: 'directory',
      title: 'products',
      type: 'basic',
      icon: 'mat_outline:inventory',
      link: `/admin/dashboard/${AdminItem.PRODUCTS}`,
    },
    hasActions: true,
    columns: [
      ...NAME_COLUMNS,
      { title: 'product_type', dataKey: 'product_type' },
      { title: 'category', dataKey: 'product_type.category' },
      { title: 'quantity', dataKey: 'quantity' },
    ],
  },
  [AdminItem.PRODUCT_TYPE_PARAMS]: {
    id: AdminItem.PRODUCT_TYPE_PARAMS,
    title: 'product.type.params',
    navigation: {
      id: 'directory',
      title: 'product.type.params',
      type: 'basic',
      icon: 'mat_outline:format_list_bulleted',
      link: `/admin/dashboard/${AdminItem.PRODUCT_TYPE_PARAMS}`,
    },
    hasActions: true,
    columns: [
      ...NAME_COLUMNS,
      { title: 'product_type', dataKey: 'product_type' },
      { title: 'type', dataKey: 'type' },
      { title: 'is_mandatory', dataKey: 'is_mandatory' },
    ],
  },
  [AdminItem.DRONES]: {
    id: AdminItem.DRONES,
    title: 'drones',
    navigation: {
      id: 'directory',
      title: 'drones',
      type: 'basic',
      icon: 'mat_outline:airplanemode_active',
      link: `/admin/dashboard/${AdminItem.DRONES}`,
    },
    hasActions: true,
    columns: [
      { title: 'model', dataKey: 'model' },
      { title: 'working_time_minutes', dataKey: 'working_time' },
      { title: 'distance_km', dataKey: 'distance' },
      { title: 'weight_kg', dataKey: 'weight' },
    ],
  },
  [AdminItem.CARS]: {
    id: AdminItem.CARS,
    title: 'cars',
    navigation: {
      id: 'directory',
      title: 'cars',
      type: 'basic',
      icon: 'mat_outline:directions_car',
      link: `/admin/dashboard/${AdminItem.CARS}`,
    },
    hasActions: true,
    columns: [
      { title: 'model', dataKey: 'model' },
      { title: 'year', dataKey: 'year' },
      { title: 'distance', dataKey: 'distance' },
      { title: 'engine', dataKey: 'engine' },
      { title: 'fuel_type', dataKey: 'fuel_type' },
      { title: 'color', dataKey: 'color' },
      { title: 'licence_plate', dataKey: 'licence_plate' },
    ],
  },
  [AdminItem.BRIGADE_REQUESTS]: {
    id: AdminItem.BRIGADE_REQUESTS,
    title: 'brigade.requests',
    navigation: {
      id: 'admin',
      title: 'brigade.requests',
      type: 'basic',
      icon: 'mat_outline:assignment',
      link: `/admin/dashboard/${AdminItem.BRIGADE_REQUESTS}`,
    },
    hasActions: false,
    columns: [
      { title: 'product', dataKey: 'product' },
      { title: 'product_type', dataKey: 'product_type' },
      { title: 'complex', dataKey: 'complex' },
      { title: 'quantity', dataKey: 'quantity' },
      { title: 'status', dataKey: 'status' },
      { title: 'created.at', dataKey: 'created_at' },
    ],
  },
  [AdminItem.WAREHOUSE_REQUESTS]: {
    id: AdminItem.WAREHOUSE_REQUESTS,
    title: 'warehouse.requests',
    navigation: {
      id: 'admin',
      title: 'warehouse.requests',
      type: 'basic',
      icon: 'mat_outline:swap_horiz',
      link: `/admin/dashboard/${AdminItem.WAREHOUSE_REQUESTS}`,
    },
    hasActions: false,
    columns: [
      { title: 'product', dataKey: 'product' },
      { title: 'product_type', dataKey: 'product_type' },
      { title: 'sender_warehouse', dataKey: 'sender_warehouse' },
      { title: 'receiver_warehouse', dataKey: 'receiver_warehouse' },
      { title: 'quantity', dataKey: 'quantity' },
      { title: 'status', dataKey: 'status' },
      { title: 'created.at', dataKey: 'created_at' },
    ],
  },
};

export enum INCIDENT_TYPE_ENUM {
  SEWAGE = 'SEWAGE',
  WATER_SUPPLY = 'WATER_SUPPLY',
}

export const incident_types = [
  {
    id: INCIDENT_TYPE_ENUM.WATER_SUPPLY,
    label: INCIDENT_TYPE_ENUM.WATER_SUPPLY,
  },
  {
    id: INCIDENT_TYPE_ENUM.SEWAGE,
    label: INCIDENT_TYPE_ENUM.SEWAGE,
  },
];

export enum BRANCH_LEVEL_ENUM {
  DISTRICT = 'DISTRICT',
  REGION = 'REGION',
  REPUBLIC = 'REPUBLIC',
}

export const branch_levels = [
  {
    id: BRANCH_LEVEL_ENUM.REPUBLIC,
    label: 'republic',
  },
  {
    id: BRANCH_LEVEL_ENUM.REGION,
    label: 'region',
  },
  {
    id: BRANCH_LEVEL_ENUM.DISTRICT,
    label: 'district',
  },
];

export enum WAREHOUSE_CATEGORY_ENUM {
  CENTRAL = 'CENTRAL',
}

export const warehouse_categories = [
  {
    id: WAREHOUSE_CATEGORY_ENUM.CENTRAL,
    label: 'central',
  },
];

export enum PRODUCT_TYPE_CATEGORY_ENUM {
  PRODUCT = 'PRODUCT',
  SPARE_PART = 'SPARE_PART',
}

export const product_type_categories = [
  {
    id: PRODUCT_TYPE_CATEGORY_ENUM.PRODUCT,
    label: 'product',
  },
  {
    id: PRODUCT_TYPE_CATEGORY_ENUM.SPARE_PART,
    label: 'spare_part',
  },
];

export const brigade_positions = [
  {
    id: 'MAIN_OPERATOR',
    label: 'MAIN_OPERATOR',
  },
  {
    id: 'OPERATOR',
    label: 'OPERATOR',
  },
];

export enum PRODUCT_PURPOSE_ENUM {
  FOR_SELLING = 'FOR_SELLING',
  FOR_USAGE = 'FOR_USAGE',
}

export const product_purposes = [
  {
    id: PRODUCT_PURPOSE_ENUM.FOR_SELLING,
    label: 'FOR_SELLING',
  },
  {
    id: PRODUCT_PURPOSE_ENUM.FOR_USAGE,
    label: 'FOR_USAGE',
  },
];

export enum BARCODE_TYPE_ENUM {
  EAN = 'EAN',
}

export const barcode_types = [
  {
    id: BARCODE_TYPE_ENUM.EAN,
    label: 'EAN',
  },
];

export enum PRODUCT_TYPE_PARAM_TYPE_ENUM {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  OPTIONS = 'OPTIONS',
}

export const product_type_param_types = [
  { id: PRODUCT_TYPE_PARAM_TYPE_ENUM.STRING, label: 'STRING' },
  { id: PRODUCT_TYPE_PARAM_TYPE_ENUM.NUMBER, label: 'NUMBER' },
  { id: PRODUCT_TYPE_PARAM_TYPE_ENUM.OPTIONS, label: 'OPTIONS' },
];

export const car_fuel_types = [
  { id: 'GASOLINE', label: 'GASOLINE' },
  { id: 'PETROL', label: 'PETROL' },
  { id: 'DIESEL', label: 'DIESEL' },
  { id: 'LPG', label: 'LPG' },
  { id: 'CNG', label: 'CNG' },
  { id: 'ELECTRICITY', label: 'ELECTRICITY' },
  { id: 'HYBRID', label: 'HYBRID' },
];
